
import { socketInstance, authInstance } from "config/axios.config";

export const supportChatServices = {
  getChats: async () => {
    const response = await socketInstance.get("/api/chat/support/admin/chats");
    return response.data;
  },

  assignChat: async (chatId) => {
    const response = await socketInstance.patch(
      `/api/chat/support/${chatId}/assign`
    );
    return response.data;
  },

   uploadSupportFile:
  async(file)=>{

    const formData =
    new FormData();

    formData.append(
      "file",
      file
    );


    const response =

    await authInstance.post(

     '/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

    );


    return response.data;

  }
};